import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 33 53" xmlns="http://www.w3.org/2000/svg" {...this.props}><title>segment</title><path d="M15 45H6.6L0 38.4V4.5h15v2H2v31.1L7.4 43H15zm6-32.6V2.8L23.8 0H33v12.4L27 18zm0 35v-9.6l2.8-2.8H33v12.4L27 53z" fill="currentColor" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/segment.inline.svg